import { AUTH_MESSAGES } from '@rsmaids/shared/constants/auth';
import { VALIDATION } from '@rsmaids/shared/constants/common';

export interface ValidationResult {
  isValid: boolean;
  message?: string;
}

export interface FormData {
  email: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export const validateEmailPassword = (formData: FormData): ValidationResult => {
  if (!formData.email?.trim() || !formData.password?.trim()) {
    return {
      isValid: false,
      message: AUTH_MESSAGES.ENTER_EMAIL_PASSWORD
    };
  }
  return { isValid: true };
};

// Simple login validation for email/password only
export const validateLogin = (email: string, password: string): ValidationResult => {
  if (!email?.trim() || !password?.trim()) {
    return {
      isValid: false,
      message: AUTH_MESSAGES.ENTER_EMAIL_PASSWORD
    };
  }
  return { isValid: true };
};

export const validateRegistration = (formData: FormData): ValidationResult => {
  // Check email and password first
  const emailPasswordCheck = validateEmailPassword(formData);
  if (!emailPasswordCheck.isValid) {
    return emailPasswordCheck;
  }

  // Check password confirmation
  if (formData.password !== formData.confirmPassword) {
    return {
      isValid: false,
      message: AUTH_MESSAGES.PASSWORDS_DO_NOT_MATCH
    };
  }

  // Check password length
  if (formData.password.length < VALIDATION.MIN_PASSWORD_LENGTH) {
    return {
      isValid: false,
      message: AUTH_MESSAGES.PASSWORD_MIN_LENGTH
    };
  }

  return { isValid: true };
};

export const validateEmail = (email: string): ValidationResult => {
  if (!email?.trim()) {
    return {
      isValid: false,
      message: AUTH_MESSAGES.ENTER_EMAIL_FOR_RESET
    };
  }
  return { isValid: true };
};

export const validatePasskeySetup = (formData: FormData): ValidationResult => {
  if (!formData.email?.trim() || !formData.password?.trim()) {
    return {
      isValid: false,
      message: AUTH_MESSAGES.PASSKEY_SETUP_ENTER_CREDENTIALS
    };
  }
  return { isValid: true };
};
